import {
	shortUrl,
	getShortUrl,
	getUrlLong,
	updateLongUrl,
	customUrl,
	getHistoryUrl
} from '@/api/Erp'

export default {
	async shortUrl (payload, token) {
		try {
			const response = await shortUrl.post(
				{
					longUrl: payload.longUrl
				},
				{
				headers: {
          'Authorization': `Bearer ${token}`
        }
			})
			return response.data
		} catch (error) {
      return error.response
    }
	},
	async getUrl(url, token) {
		try {
			const response = await getShortUrl.get({
				uriParams: {
					url
        },
        headers: {
					'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
	async getUrlLong(url, token) {
		try {
			const response = await getUrlLong.get({
				uriParams: {
					url
        },
        headers: {
					'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
	async getHistory(url, token) {
		try {
			const response = await getHistoryUrl.get({
				uriParams: {
					url
        },
        headers: {
					'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
	async updateUrl (payload, token) {
		try {
			const response = await updateLongUrl.put(
				payload,
				{
					headers: {
						'Authorization': `Bearer ${token}`
					}
				})
			return response.data
		} catch (error) {
      return error.response
    }
	},
	async customUrl (payload, token) {
		try {
			const response = await customUrl.post(
				payload,
				{
				headers: {
          'Authorization': `Bearer ${token}`
        }
			})
			return response.data
		} catch (error) {
      return error.response
    }
	},
	async getUrlShort(payload, token) {
		try {
			const response = await getShortUrl.get(
				payload,
				{
        
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/urltools/resources.js